import { useMemo, type Ref, SyntheticEvent, ReactNode } from 'react'
import NumberFormat from 'react-number-format'

import PlainInput, { type PlainInputProps } from '../plain-input'
import { defaultPredefinedParams, getPredefinedParams } from './mask-predefined'
import { maskType } from './mask-types'

export type NumberFormatValues = {
  floatValue: number | void
  formattedValue: string
  value: string
}

export type SourceInfo = {
  event: SyntheticEvent<HTMLInputElement>
  source: 'prop' | 'event'
}

export type PlainInputMaskedProps = {
  allowEmptyFormatting?: boolean
  isNumericString?: boolean // установить в true, если входящее value number
  format?: string | ((inputValue: string) => string)
  displayType?: 'text' | 'input'
  mask?: string | Array<string> // single char | array of single chars
  predefinedMaskType?:
    | (typeof maskType)['MASK_PHONE_RU']
    | (typeof maskType)['MASK_PHONE_KG']
    | (typeof maskType)['MASK_PHONE_KZ']
    | (typeof maskType)['MASK_PHONE_UA']
    | (typeof maskType)['MASK_SNILS']
    | (typeof maskType)['MASK_DATE']
    | (typeof maskType)['MASK_DAY_MONTH']
    | (typeof maskType)['MASK_TIME']
  prefix?: string
  onValueChange?: (a: NumberFormatValues, b: SourceInfo) => void
  isAllowed?: (a: NumberFormatValues) => boolean // при возврате false, onChange и onValueChange не будут срабатывать
  removeFormatting?: (v: string) => string
  renderText?: (formattedValue: string) => ReactNode
  getInputRef?: ((el: HTMLInputElement | null) => void) | Ref<'input'>
} & PlainInputProps

const PlainInputMasked = ({
  value,
  allowEmptyFormatting,
  isNumericString,
  format,
  displayType,
  mask,
  predefinedMaskType,
  prefix,
  onValueChange,
  isAllowed,
  removeFormatting,
  renderText,
  type,
  ...other // PlainInput props
}: PlainInputMaskedProps) => {
  const predefinedParams = useMemo(() => {
    return predefinedMaskType ? getPredefinedParams(predefinedMaskType) : defaultPredefinedParams
  }, [predefinedMaskType])

  const props = {
    value,
    onValueChange,
    customInput: PlainInput,
    prefix,
    isAllowed,
    removeFormatting,
    isNumericString,
    displayType,
    allowEmptyFormatting,
    renderText,
    thousandSeparator: ' ',
    ...predefinedParams,
    ...(format ? { format } : {}),
    ...(mask ? { mask } : {}),
    ...other,
  }

  return <NumberFormat {...props} />
}

export default PlainInputMasked
